<template>
  <div class="lbv-leak-list animated fadeIn roundedCard">
    <div class="row">
      <div class="col-lg-12">
        <b-card>
          <div class="col-lg-12 leak-list-header">
            <span class="lbv-page-title">Event List</span>
          </div>
          <div class="row secondary lbv-search">
            <form
              class="lbv-search-filter leak-list-form"
              @submit.prevent="search"
            >
              <div class="leaklistFilters w-100">
                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="Device ID"
                      label-for="device-id"
                    >
                      <input
                        id="device-id"
                        v-model="searchDeviceID"
                        type="text"
                        class="form-control full-width"
                        placeholder="LeakBot ID"
                      >
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      label="Tenant"
                      label-for="select-tenant"
                    >
                      <b-form-select
                        id="select-tenant"
                        v-model="tenantSelection"
                        class="full-width"
                      >
                        <option :value="null">
                          All Tenants
                        </option>
                        <option
                          v-for="tenant in tenants"
                          v-bind="$attrs"
                          :key="tenant.id"
                          :value="{ id: tenant.id }"
                          @option="$emit('option', $event.target.value)"
                        >
                          {{ tenant.name }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      label="Type"
                      label-for="type-filter"
                    >
                      <b-form-select
                        id="type-filter"
                        v-model="typeSelection"
                        class="full-width"
                      >
                        <option :value="null">
                          All
                        </option>
                        <option value="1">
                          Leak
                        </option>
                        <option value="2">
                          No Leak
                        </option>
                        <option value="12">
                          User Triggered Leak
                        </option>
                        <option value="3">
                          Initial Monitoring
                        </option>
                        <option value="4">
                          Suspected
                        </option>
                        <option value="14">
                          High Usage
                        </option>
                        <option value="15">
                          No High Usage
                        </option>
                        <option value="5">
                          Has Signal
                        </option>
                        <option value="16">
                          High Signal
                        </option>
                        <option value="13">
                          Low Signal
                        </option>
                        <option value="17">
                          Lost Signal
                        </option>
                        <option value="11">
                          No Signal
                        </option>
                        <option value="18">
                          Registered
                        </option>
                        <option value="7">
                          Hardware Fault
                        </option>
                        <option value="8">
                          Low Battery
                        </option>
                        <option value="9">
                          On Hot Pipe
                        </option>
                        <option value="20">
                          Waiting On Pipe
                        </option>
                        <option value="21">
                          On Pipe
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="3">
                    <b-form-group
                      label="Date from"
                      label-for="date-from"
                    >
                      <b-form-input
                        id="date-from"
                        v-model="dateFrom"
                        type="date"
                        class="date-picker w-100"
                        name="dateFrom"
                        placeholder="YYYY-MM-DD"
                      />
                    </b-form-group>
                  </b-col cols="3">
                  <b-col>
                    <b-form-group
                      label="Date to"
                      label-for="date-to"
                    >
                      <input
                        id="date-to"
                        v-model="dateTo"
                        type="date"
                        class="form-control date-picker w-100"
                        name="dateTo"
                        placeholder="YYYY-MM-DD"
                      >
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group
                      label="Status"
                      label-for="status-filter"
                    >
                      <b-form-select
                        id="status-filter"
                        v-model="statusSelection"
                        class="full-width"
                      >
                        <option :value="null">
                          All
                        </option>
                        <option value="open">
                          open
                        </option>
                        <option value="closed">
                          closed
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="3"
                    class="d-flex align-items-center"
                  >
                    <b-button
                      id="applyBtn"
                      type="submit"
                      variant="primary"
                      class="w-100 mr-3"
                      :disabled="applyBtnDisabled"
                    >
                      Apply
                    </b-button>
                    <b-button
                      type="submit"
                      variant="primary"
                      class="w-100"
                      @click.prevent="downloadReport"
                    >
                      <span class="download">Export CSV File</span>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </form>
          </div>
          <b-alert
            :show="errorMessage != ''"
            variant="danger"
          >
            {{ errorMessage }}
          </b-alert>
          <b-table
            responsive
            striped
            hover
            :items="eventList"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template
              slot="leakbotId"
              slot-scope="data"
            >
              <!--<router-link :to="`deviceview/${data.value}`" class="deviceLink">{{data.value}}</router-link>-->
              <router-link
                :to="{ name: 'DeviceView', params: { deviceID: data.value }}"
                class="deviceLink"
              >
                {{ data.value }}
              </router-link>
            </template>
            <template
              slot="needHelp"
              slot-scope="data"
            >
              <strong v-if="data.item.needHelp === 'GetHelp'">{{ data.value }}</strong>
              <div v-else>
                {{ data.value }}
              </div>
            </template>
            <template
              slot="repairComplete"
              slot-scope="data"
            >
              <strong v-if="data.item.repairComplete === 'GetHelp'">{{ data.value }}</strong>
              <div v-else>
                {{ data.value }}
              </div>
            </template>
          </b-table>
          <b-button
            class="page prev"
            variant="primary"
            size="sm"
            :disabled="pageNumber === 1"
            @click.prevent="page"
          >
            Prev
          </b-button>

          <b-button
            class="page next"
            variant="primary"
            size="sm"
            :disabled="!hasNextPage"
            @click.prevent="page"
          >
            Next
          </b-button>
          <div class="current-page">
            Page: {{ pageNumber }}
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import eventListMixin from '../mixins/eventListMixin'

export default {
  name: 'EventList',
  mixins: [eventListMixin]
}
</script>
<style media="screen">
  .lbv-leak-list .leaklistFilters .full-width {
    width: 100% !important;
  }

  .lbv-leak-list .leaklistFilters label {
    font-size: 0.8rem
  }
</style>
